import React from 'react'
import { Card, IconWrapper, AccessIcon, CardTitle, AccessGrid } from './styled'
import useIsMobile from '../../../hooks/useIsMobile'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const Cards = ({ list, iconColor, onClick }) => {
	const isMobile = useIsMobile()
	const history = useHistory()

	return (
		<AccessGrid>
			{list.map(item => {
				const IconComponent = item.Icon
				return (
					<Card onClick={() => onClick(item.routes)}>
						<IconWrapper size={24}>
							<AccessIcon>
								<IconComponent color={iconColor} width={24} height={24} />
							</AccessIcon>
						</IconWrapper>
						<CardTitle>{item.title}</CardTitle>
					</Card>
				)
			})}
		</AccessGrid>
	)
}

export default Cards
